const SendIcon = ({ width = 15, height = 15, color = "#000" }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
  >
    <path
      d="M1.444 6.669a2 2 0 0 0-.865 3.337l3.412 3.408V20h6.593l3.435 3.43a1.987 1.987 0 0 0 1.408.588 2.034 2.034 0 0 0 .51-.066 1.978 1.978 0 0 0 1.42-1.379L23.991.021ZM2 8.592l17.028-5.02L5.993 16.586v-4Zm13.44 13.424L11.413 18h-4L20.446 4.978Z"
      data-name="01 align center"
      fill={color}
    />
  </svg>
);

export default SendIcon;
